import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.map.get-or-insert.js";
import "core-js/modules/esnext.map.get-or-insert-computed.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import axios from "axios";
import { Component, Prop, Ref, Vue, Watch } from "vue-facing-decorator";
import { D2 } from "@terrastruct/d2";
import { waitingJob } from "@/util/job.utils";
import { alertError } from "@/util/dialog";
import StandardButton from "@/components/buttons/StandardButton.vue";
import LightButton from "@/components/buttons/LightButton.vue";
import WInput from "@/components/form/w-input.vue";
import IconButton from "@/components/buttons/IconButton.vue";
import WToolTip from "@/components/tooltip/w-toolTip.vue";
import WDialog from "@/components/wrappers/w-dialog.vue";
import ConfirmDialog from "@/components/dialogs/ConfirmDialog.vue";
import { injectD2DiagramThemeAndClasses } from "@/util/d2Util";
import PanZoomViewer from "@/components/panZoomViewer/PanZoomViewer.vue";
import { getDoc2SpeachAllowedExtensions } from "@/util/fileUtil";
import { convertSvgToPng } from "@/util/imageUtils";
let DiagramEditor = class DiagramEditor extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "id", void 0);
    _defineProperty(this, "diagramData", void 0);
    _defineProperty(this, "hideActionsButtons", void 0);
    _defineProperty(this, "processing", void 0);
    _defineProperty(this, "saved", void 0);
    _defineProperty(this, "openEditMode", void 0);
    _defineProperty(this, "visionEnabled", void 0);
    _defineProperty(this, "panzoomViewerComponent", void 0);
    _defineProperty(this, "currentDiagramData", null);
    _defineProperty(this, "diagramSVG", '');
    _defineProperty(this, "d2", new D2());
    _defineProperty(this, "isEditing", true);
    _defineProperty(this, "messages", []);
    _defineProperty(this, "selectedFiles", []);
    _defineProperty(this, "exploredFilesHistory", []);
    _defineProperty(this, "conversationHistory", []);
    _defineProperty(this, "currentD2Code", '');
    _defineProperty(this, "lastCompiledDiagram", null);
    _defineProperty(this, "chatInputValue", '');
    _defineProperty(this, "isProcessing", false);
    _defineProperty(this, "diagramSaved", false);
    _defineProperty(this, "isDownloadingPng", false);
    _defineProperty(this, "isDraggingOverTextArea", false);
    _defineProperty(this, "displayDiagramHelpDialog", false);
    _defineProperty(this, "displayDiscardConfirmationDialog", false);
    _defineProperty(this, "displayNewDiagramConfirmationDialog", false);
    _defineProperty(this, "DIAGRAM_PNG_FILE_NAME", "diagram.png");
    // on exporte en 2x pour un PNG net a l'ecran comme a l'impression, imageUtils rabaissant l'echelle si le diagramme est trop grand.
    _defineProperty(this, "DIAGRAM_PNG_EXPORT_SCALE", 2);
    _defineProperty(this, "DIAGRAM_PNG_OBJECT_URL_TTL_MS", 1000);
    _defineProperty(this, "LS_DIAGRAM_GENERATOR_PREFIX", "speach.ai.diagramGenerator.");
    _defineProperty(this, "LS_DIAGRAM_GENERATOR_HELP_VIEWED", `${this.LS_DIAGRAM_GENERATOR_PREFIX}helpViewed`);
  }
  mounted() {
    this.handleDiagramEditorData();
    this.showDiagramGeneratorHelpDialog();
  }
  get canSendMsg() {
    return !this.isProcessing && !this.isExtractingFileContent && (this.allFilesSuccessfullyProcessed || this.chatInputValue.trim() && !this.selectedFiles.length);
  }
  get allFilesSuccessfullyProcessed() {
    return !!this.selectedFiles.length && this.selectedFiles.every(file => file.jobStatus === 'success');
  }
  get isExtractingFileContent() {
    return this.selectedFiles.some(file => !file.jobStatus);
  }
  get canDownloadPng() {
    return !this.isProcessing && !this.isDownloadingPng && !!this.diagramSVG?.length;
  }
  get hasUnsavedChanges() {
    return this.currentD2Code !== (this.currentDiagramData?.d2Code || '');
  }
  get showEmptyChatPlaceholder() {
    return this.messages.length === 0;
  }
  get reversedMessages() {
    return [...this.messages].reverse();
  }
  get inputPlaceholderKey() {
    return this.currentDiagramData?.d2Code || this.messages.length > 0 ? 'diagramEditor.inputPlaceholderChanges' : 'diagramEditor.inputPlaceholder';
  }
  get diagramEditStatus() {
    return this.hasUnsavedChanges ? this.$t('diagramEditor.changesUnSavedTooltip') : this.$t('diagramEditor.changesSavedTooltip');
  }
  get diagramEditStatusIcon() {
    return this.hasUnsavedChanges ? 'content-save-alert-outline' : 'content-save-check-outline';
  }
  get acceptedFilesTypes() {
    return getDoc2SpeachAllowedExtensions(this.visionEnabled);
  }
  onDiagramDataChanged() {
    this.currentDiagramData = this.diagramData;
    if (this.currentDiagramData) {
      this.handleDiagramEditorData();
    } else {
      this.clearDiagramData();
    }
  }
  onEditModeChanged() {
    this.isEditing = this.openEditMode;
  }
  onSavingStatusChanged() {
    this.isProcessing = this.processing;
  }
  onDiagramSaved() {
    this.diagramSaved = this.saved;
  }
  isExtractionSuccessful(file) {
    return file.jobStatus === 'success';
  }
  isExtractionFailed(file) {
    return file.jobStatus === 'error';
  }
  isExtractionProcessing(file) {
    return !file.jobStatus;
  }
  getExtractionResultIcon(file) {
    if (this.isExtractionFailed(file)) {
      return 'close-octagon';
    } else if (this.isExtractionSuccessful(file)) {
      return 'check-circle';
    }
    return '';
  }
  getExtractionResultClass(file) {
    if (this.isExtractionFailed(file)) {
      return 'file-error-flag';
    } else if (this.isExtractionSuccessful(file)) {
      return 'file-success-flag';
    }
    return '';
  }
  handleDiagramEditorData() {
    this.isEditing = this.openEditMode;
    this.isProcessing = this.processing;
    this.currentDiagramData = this.diagramData;
    const code = this.currentDiagramData?.d2Code || '';
    this.currentD2Code = code;
    this.conversationHistory = [];
    this.messages = [];
    this.applyDiagramOutput(code);
  }
  async applyDiagramOutput(d2Code) {
    if (!d2Code?.trim()) {
      this.diagramSVG = '';
      this.lastCompiledDiagram = null;
      this.destroyPanzoom();
      return;
    }
    try {
      const codeWithTheme = injectD2DiagramThemeAndClasses(d2Code);
      const result = await this.d2.compile(codeWithTheme, {
        center: true
      });
      this.lastCompiledDiagram = result.diagram;
      this.diagramSVG = await this.d2.render(result.diagram, result.renderOptions);
      this.panzoomViewerComponent.initPanzoom();
    } catch (err) {
      this.destroyPanzoom();
    }
  }
  getSelectedFileIcon(type) {
    if (type.startsWith("image/")) {
      return "image-outline";
    } else if (type.startsWith("video/")) {
      return "play-box-outline";
    } else {
      return "file-document-outline";
    }
  }
  removeSelectedFile(file) {
    this.selectedFiles = this.selectedFiles.filter(sfile => sfile !== file);
  }
  async sendMessage() {
    if (!this.canSendMsg) {
      return;
    }
    const message = this.chatInputValue.trim();
    this.isProcessing = true;
    const filesMeta = this.selectedFiles.map(file => ({
      name: file?.raw?.name,
      type: file?.raw?.type
    }));
    this.messages.push({
      role: 'user',
      text: message,
      filesMeta
    });
    this.chatInputValue = '';
    try {
      const diagramGenerationRequest = {
        conversationHistory: this.conversationHistory,
        userPrompt: message,
        currentD2Code: this.currentD2Code,
        userFilesExtractedData: this.selectedFiles.map(file => file.extractedData),
        exploredFilesHistory: this.exploredFilesHistory
      };
      const formData = new FormData();
      formData.append('diagramGenerationRequestJson', JSON.stringify(diagramGenerationRequest));
      const {
        data
      } = await axios.post(`/api/v2/chapters/${this.id}/generate-diagram`, formData);
      await this.waitDiagramGenerationProceed(message, data);
    } catch (e) {
      this.messages[this.messages.length - 1].errorOccurred = true;
      alertError(this.$t('errors.default'));
    } finally {
      this.isProcessing = false;
      this.$nextTick(() => {
        this.$refs.diagramChatInput?.focus();
      });
    }
  }
  async requestFileContentsExtraction(userFile) {
    try {
      const formData = new FormData();
      formData.append('file', userFile.raw);
      const {
        data
      } = await axios.post(`/api/v2/diagram-generator/handle-file`, formData);
      await this.waitContentExtractionProceed(userFile, data);
    } catch (e) {
      userFile.jobStatus = 'error';
      if (e?.errorData && e?.errorData?.fileInError) {
        alertError(this.$t('diagramEditor.docExtractionError'));
      } else {
        alertError(this.$t('errors.default'));
      }
    }
  }
  discardChanges() {
    if (this.hasUnsavedChanges) {
      this.displayDiscardConfirmationModal();
    } else {
      this.cancelChanges();
    }
  }
  onFileUpload(_, userFile) {
    this.isDraggingOverTextArea = false;
    // remove eventual duplicates (keep old version, or new version if old version has failed)
    const seen = new Map();
    for (const file of this.selectedFiles) {
      const key = `${file?.raw?.name}-${file?.raw?.size}`;
      const previous = seen.get(key);
      if (!previous || this.isExtractionFailed(previous)) {
        seen.set(key, file);
      }
    }
    this.selectedFiles = Array.from(seen.values());
    if (this.selectedFiles.includes(userFile)) {
      this.requestFileContentsExtraction(userFile);
    }
  }
  showHelpModal() {
    this.displayDiagramHelpDialog = true;
  }
  closeDiagramHelpDialog() {
    this.displayDiagramHelpDialog = false;
  }
  displayNewDiagramConfirmationModal() {
    this.displayNewDiagramConfirmationDialog = true;
  }
  closeNewDiagramConfirmationModal() {
    this.displayNewDiagramConfirmationDialog = false;
  }
  displayDiscardConfirmationModal() {
    this.displayDiscardConfirmationDialog = true;
  }
  closeDiscardConfirmationModal() {
    this.displayDiscardConfirmationDialog = false;
  }
  editDiagram() {
    this.messages = [];
    this.conversationHistory = [];
    this.isEditing = true;
  }
  cancelChanges() {
    this.messages = [];
    this.conversationHistory = [];
    this.clearSelectedFiles();
    this.exploredFilesHistory = [];
    if (this.currentDiagramData?.d2Code) {
      this.currentD2Code = this.currentDiagramData.d2Code;
      this.applyDiagramOutput(this.currentD2Code);
      this.isEditing = false;
    } else {
      this.currentD2Code = '';
      this.diagramSVG = '';
      this.destroyPanzoom();
      this.isEditing = true;
    }
    this.$emit('cancelChanges');
  }
  confirmNewDiagram() {
    this.$emit('restart');
  }
  clearDiagramData() {
    this.currentDiagramData = null;
    this.currentD2Code = '';
    this.conversationHistory = [];
    this.clearSelectedFiles();
    this.exploredFilesHistory = [];
    this.messages = [];
    this.diagramSVG = '';
    this.isEditing = true;
    this.destroyPanzoom();
  }
  async downloadDiagramAsPng() {
    if (!this.canDownloadPng) {
      return;
    }
    this.isDownloadingPng = true;
    try {
      const diagramPng = await convertSvgToPng(this.diagramSVG, this.DIAGRAM_PNG_FILE_NAME, undefined, this.DIAGRAM_PNG_EXPORT_SCALE);
      const pngObjectUrl = URL.createObjectURL(diagramPng);
      const downloadLink = document.createElement('a');
      downloadLink.href = pngObjectUrl;
      downloadLink.download = this.DIAGRAM_PNG_FILE_NAME;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      // on libere l'URL une fois le telechargement amorce: revoquer immediatement l'annule sur certains navigateurs.
      window.setTimeout(() => URL.revokeObjectURL(pngObjectUrl), this.DIAGRAM_PNG_OBJECT_URL_TTL_MS);
    } catch (e) {
      alertError(this.$t('diagramEditor.downloadPngError'));
    } finally {
      this.isDownloadingPng = false;
    }
  }
  saveDiagram() {
    if (!this.currentD2Code?.length || this.currentD2Code === this.currentDiagramData?.d2Code) {
      return;
    }
    this.$emit('save', this.currentD2Code, this.lastCompiledDiagram, this.diagramSVG);
  }
  async waitDiagramGenerationProceed(userPrompt, jobID) {
    const data = await waitingJob(jobID);
    this.conversationHistory.push({
      userPrompt,
      acknowledgeMessage: data.acknowledgeMessage,
      d2Code: data.d2Code
    });
    this.exploredFilesHistory = data.exploredFiles;
    this.messages.push({
      role: 'assistant',
      text: data.acknowledgeMessage
    });
    this.currentD2Code = data.d2Code;
    await this.applyDiagramOutput(this.currentD2Code);
    this.clearSelectedFiles();
    if (this.hideActionsButtons) {
      this.$emit('change', this.currentD2Code);
    }
  }
  async waitContentExtractionProceed(userFile, jobID) {
    userFile.extractedData = await waitingJob(jobID);
    userFile.jobStatus = 'success';
  }
  clearSelectedFiles() {
    this.selectedFiles = [];
  }
  showDiagramGeneratorHelpDialog() {
    const helpViewed = localStorage.getItem(this.LS_DIAGRAM_GENERATOR_HELP_VIEWED);
    if (!helpViewed || helpViewed === 'false') {
      this.displayDiagramHelpDialog = true;
      localStorage.setItem(this.LS_DIAGRAM_GENERATOR_HELP_VIEWED, String('true'));
    }
  }
  destroyPanzoom() {
    this.panzoomViewerComponent?.destroyPanzoom();
  }
};
__decorate([Prop({
  required: true
})], DiagramEditor.prototype, "id", void 0);
__decorate([Prop({
  required: true
})], DiagramEditor.prototype, "diagramData", void 0);
__decorate([Prop({
  default: false
})], DiagramEditor.prototype, "hideActionsButtons", void 0);
__decorate([Prop({
  default: false
})], DiagramEditor.prototype, "processing", void 0);
__decorate([Prop({
  default: false
})], DiagramEditor.prototype, "saved", void 0);
__decorate([Prop({
  default: false
})], DiagramEditor.prototype, "openEditMode", void 0);
__decorate([Prop({
  default: false
})], DiagramEditor.prototype, "visionEnabled", void 0);
__decorate([Ref('panzoomViewerComponent')], DiagramEditor.prototype, "panzoomViewerComponent", void 0);
__decorate([Watch("diagramData")], DiagramEditor.prototype, "onDiagramDataChanged", null);
__decorate([Watch("openEditMode")], DiagramEditor.prototype, "onEditModeChanged", null);
__decorate([Watch("processing")], DiagramEditor.prototype, "onSavingStatusChanged", null);
__decorate([Watch("saved")], DiagramEditor.prototype, "onDiagramSaved", null);
DiagramEditor = __decorate([Component({
  components: {
    PanZoomViewer,
    ConfirmDialog,
    WDialog,
    WToolTip,
    IconButton,
    WInput,
    LightButton,
    StandardButton
  },
  emits: ["save", "cancelChanges", "restart", "change"]
})], DiagramEditor);
export default DiagramEditor;